import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissions } from '@/actions';
import { getAuthUser, getProject } from '@/selectors';

export const useFetchPermissions = () => {
	const dispatch = useDispatch();
	const project = useSelector(getProject);
	const user = useSelector(getAuthUser);

	useEffect(() => {
		if (project && user?.token) {
			dispatch(fetchPermissions({ accessToken: user.token, projectId: project.projectId }));
		}
	}, [project?.projectId, user?.token, dispatch]);
};
